import dayjs from 'dayjs';

export const chartHelper = {
  transformData: (diffItems: Array<{ date: string; value: number }>, label = 'Antal') => {
    const transformedData: (string | number)[][] = [['Datum', label]];

    if (!diffItems) {
      return transformedData; // Return the header if diffItems is undefined
    }

    // Transform the data
    diffItems.forEach((item) => {
      transformedData.push([dayjs(item.date).format('YYYY-MM-DD'), item.value]);
    });

    return transformedData;
  },
};
